// THEMES is the overall structure of our themes and actions
export const THEMES = Object.freeze({
  samenleving: ["netwerk", "buurthuis", "slachtoffers", "gevarieerd"],
  sport_ontspanning: ["sporthal", "recreatiezone", "skatepark", "zwembad"],
  samenwerking: ["invoeren", "crowdfunding", "prive_initiativen", "studie"],
  groene: ["ruimte", "bomenbeleidsplan", "mobiliteit", "schoolomgeving"],
  ruimtelijke: ["patrimonium", "uitvoeringsplannen", "parkske"],
  veilige: ["inzetten", "veiligheid", "zwerfvuilbeleid"],
});
